export const iconFontAwesomeAutomotiveTruckMonster = (
	<i className="fa-solid fa-truck-monster"></i>
);
